import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "forge_cookie_consent_v1";

export const CookieBanner = () => {
  const [show, setShow] = useState(false);
  useEffect(() => { try { setShow(!localStorage.getItem(KEY)); } catch (e) { setShow(false); } }, []);
  if (!show) return null;
  const pick = (v) => { try { localStorage.setItem(KEY, JSON.stringify({ choice: v, at: new Date().toISOString() })); } catch (e) { /* storage blocked */ } setShow(false); };
  return (
    <div data-testid="cookie-banner" className="glass-strong fixed inset-x-3 bottom-3 z-[60] mx-auto flex max-w-3xl flex-wrap items-center gap-3 rounded-2xl p-4 text-sm text-white/75 shadow-2xl md:inset-x-auto md:left-1/2 md:-translate-x-1/2">
      <p className="min-w-0 flex-1">FORGE uses strictly necessary cookies for sign-in and security. We don't use advertising cookies. See our <Link to="/legal/cookies" className="text-[#22d3ee]">Cookie Policy</Link>.</p>
      <button data-testid="cookie-essential-only" onClick={() => pick("essential")} className="rounded-full border border-white/15 px-4 py-1.5 text-xs">Essential only</button>
      <button data-testid="cookie-accept" onClick={() => pick("all")} className="rounded-full bg-fire px-4 py-1.5 text-xs font-semibold">Accept</button>
    </div>
  );
};
